import { Component, ErrorInfo, ReactNode } from "react";
import { deleteAllFilesAndFolders } from "@features/FxLauncherLoader/utils/helpers";

interface Props {
	children?: ReactNode;
}

interface State {
	hasError: boolean;
	error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
	public state: State = {
		hasError: false,
	};


	public static getDerivedStateFromError(_err: Error): State {
		// Update state so the next render will show the fallback UI.
		return { hasError: true, error: _err};
	}

	public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error("Uncaught error:", error, errorInfo);
	}



	public render() {
		if (this.state.hasError) {
			function clearCache(): void {
				// flush all local storage and cookies
				// Clear local storage
				localStorage.clear();

				// Clear cookies
				document.cookie.split(";").forEach((c) => {
					document.cookie = c
						.replace(/^ +/, "")
						.replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
				});

				const id = setTimeout(()=>window.location.reload(), 1000);
				void deleteAllFilesAndFolders(["APP_DATA", "Default"],()=>{clearTimeout(id)}).then(()=>window.location.reload()).catch(()=>window.location.reload());

			}
			console.log("Clearing cache",FxApi);


			return (
				<div style={{margin: "10pt 10pt 10pt 20pt"}}>
					<h1>Sorry... there was an error 🛠️</h1>
					<p>{this.state.error?.message}</p>
					<pre>{this.state.error?.stack}</pre>

					<button onClick={clearCache} style={{backgroundColor: 'gray', marginTop: "10px", padding: "5pt 10pt 5pt 10pt"}} >clear cache</button>


				</div>
			);
		}

		return this.props.children;
	}
}
